export interface IMenu {
  identifier: string;
  sortOrder: number;
  name: string;
  name_en: string;
  name_cn: string;
  name_kr: string;
  name_base: string;
  message: string;
  message_en: string;
  message_cn: string;
  message_kr: string;
  soldOut: boolean;
  thumbnailImageFileName: string;
  imageFileName: string;
  itemCategory: string;
  superItem: string;
  price: number;
  price_tax_excluded: string;
  recommended: string;
  subIdentifier: string;
  subName: string;
  ranking: string;
  foodKind: string;
  allYouCanEat: boolean;
  anotherShowMinuteFrom: number;
  anotherShowMinuteTo: number;
  minimumOrder: number;
  orderNumber: number;
  menuMessageIndex: number;
  isSpicy: boolean;
  quantity: number;
}
export class MenuDTO implements IMenu {
  identifier: string;
  sortOrder: number;
  name: string;
  name_en: string;
  name_cn: string;
  name_kr: string;
  name_base: string;
  message: string;
  message_en: string;
  message_cn: string;
  message_kr: string;
  soldOut: boolean;
  thumbnailImageFileName: string;
  imageFileName: string;
  itemCategory: string;
  superItem: string;
  price: number;
  price_tax_excluded: string;
  recommended: string;
  subIdentifier: string;
  subName: string;
  ranking: string;
  foodKind: string;
  allYouCanEat: boolean;
  anotherShowMinuteFrom: number;
  anotherShowMinuteTo: number;
  minimumOrder: number;
  orderNumber: number;
  menuMessageIndex: number;
  isSpicy: boolean;
  quantity: number;
}

export default class Menu extends MenuDTO {
  constructor(dto?: MenuDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      sortOrder: 0,
      name: "",
      name_en: "",
      name_cn: "",
      name_kr: "",
      name_base: "",
      message: "",
      message_en: "",
      message_cn: "",
      message_kr: "",
      soldOut: false,
      thumbnailImageFileName: "",
      imageFileName: "",
      itemCategory: "",
      superItem: "",
      price: 0,
      price_tax_excluded: "0",
      recommended: "0",
      subIdentifier: "",
      subName: "",
      ranking: "",
      foodKind: "0",
      allYouCanEat: true,
      anotherShowMinuteFrom: -1,
      anotherShowMinuteTo: -1,
      minimumOrder: 0,
      orderNumber: -1,
      menuMessageIndex: 0,
      isSpicy: false,
      quantity: 0,
    });
  }
}
